import { CustomerProductList } from "@redotech/redo-model/customer-product-list/customer-product-list-definition";
import * as z from "zod/v4";

export const createCustomerProductList = {
  name: "createCustomerProductList" as const,
  input: z.null(),
  output: z.object({ customerProductList: CustomerProductList.optional() }),
};
